import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  className?: string;
  i18nKey?: string;
  children: ReactNode;
  onClick?: () => void;
}

export const HelpLink = ({ className, i18nKey, children, onClick }: IProps) => {
  const { t } = useTranslation();

  if (!i18nKey) {
    return <>{children}</>;
  }

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={t(i18nKey)}
      className={className}
      onClick={onClick}
    >
      {children}
    </a>
  );
};
